import React, { useEffect, useState } from "react";
import InputWithIcon from "../FormFields/InputWithIcon";
import { icons } from "../../assets/icons";
import { canSendBackForRework, hasAnyChildInRework } from "../../utils/helpers";

const DetailsCard = ({
  rows = [],
  data = [],
  wrapperClassName = "",
  rowClassName = "",
  customRow,
  showGlobalSearch = false,
  isRejectApproveButtonEnable = false,
  rejectHandler,
  approveHandler,
  editApproveHandler,
  reworkHandler,
  userLabel,
  sendRowDataInHandler = false,
  isVoucher = false,
  approveRejectButtonStage,
  isPartiallyActive = true
}) => {
  const [dataToShow, setDataToShow] = useState(data || []);

  useEffect(() => {
    setDataToShow(data || []);
  }, [data]);

  const onSearch = (e) => {
    setDataToShow(data?.filter((row) => JSON.stringify(row).includes(e)));
  };
  return (
    <div
      className={`flex flex-col gap-y-4 ${wrapperClassName} font-size-medium pb-40`}
      // style={{ zIndex: -1 }}
    >
      {/* {showGlobalSearch && (
        <InputWithIcon
          placeholder="Search"
          containerClassName="search-input-wrapper !text-[16px]"
          inputClassName="!text-[16px]"
          rightIcon={icons.searchIcon}
          onChange={onSearch}
        />
      )} */}
      {dataToShow?.map((rowData, i) => {
        return (
          <> 
            <div
              className="rounded-[1.2rem] bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)]"
              key={"row-" + i}
            >
              {rows.map((row, index) => {
                if (customRow) {
                  if (customRow(row, rowData)) {
                    return customRow(row, rowData);
                  }
                }

                return (
                  <div
                    className={`min-h-[5rem] border-b-[1px] border-[var(--borderGray2)] flex items-center px-5 py-2 ${rowClassName}`}
                    key={"column-" + index}
                    style={{ overflowWrap: "anywhere" }}
                  >
                    <div
                      className="min-w-[18rem] font-size-medium"
                      style={{ overflowWrap: "anywhere" }}
                    >
                      {row?.Header}
                    </div>
                    {row.Cell ? (
                      row.Cell(rowData)
                    ) : (
                      <div
                        className="font-size-medium"
                        style={{ overflowWrap: "anywhere" }}
                      >
                        {rowData?.[row?.accessor] || "-"}
                      </div>
                    )}
                  </div>
                );
              })}
              {rowData?.newL1Status === 'Rejected' || rowData?.newL2Status === 'Rejected' ? null :
              <div>
              {(isVoucher &&
                isRejectApproveButtonEnable &&
                rowData?.pendingDocs?.length) ||
              (!isVoucher &&
                ((approveRejectButtonStage &&
                  isRejectApproveButtonEnable &&
                  approveRejectButtonStage(rowData)) ||
                  (!approveRejectButtonStage &&
                    isRejectApproveButtonEnable))) ? (
                <div className="flex w-full grow gap-px">
                  {(() => {
                    const actionsDisabled = hasAnyChildInRework(rowData, userLabel);
                    return (
                      <>
                        {isPartiallyActive && <div
                          className={`h-20 flex items-center justify-center w-full text-[var(--pendingYellow)] rounded-bl-lg font-family-medium ${
                            actionsDisabled ? "bg-[#f5f5f5] cursor-not-allowed opacity-50" : "bg-[#f9eaaf] cursor-pointer"
                          }`}
                          onClick={actionsDisabled ? undefined : () =>
                            editApproveHandler(
                              sendRowDataInHandler ? rowData : rowData?.parentId
                            )
                          }
                        >
                          Partial Approve
                        </div>}
                        <div
                          className={`h-20 flex items-center justify-center w-full text-[var(--textRed)] font-family-medium ${
                            actionsDisabled ? "bg-[#f5f5f5] cursor-not-allowed opacity-50" : "bg-[#FFCBCB] cursor-pointer"
                          }`}
                          onClick={actionsDisabled ? undefined : () =>
                            rejectHandler(
                              sendRowDataInHandler ? rowData : rowData?.parentId
                            )
                          }
                        >
                          Reject
                        </div>
                        {canSendBackForRework(rowData, userLabel) && reworkHandler && (
                          <div
                            className={`h-20 flex items-center justify-center w-full text-[#FF8C00] font-family-medium ${
                              actionsDisabled ? "bg-[#f5f5f5] cursor-not-allowed opacity-50" : "bg-[#FFE5B4] cursor-pointer"
                            }`}
                            onClick={actionsDisabled ? undefined : () =>
                              reworkHandler(
                                sendRowDataInHandler ? rowData : rowData?.parentId
                              )
                            }
                          >
                            Send Back for Rework
                          </div>
                        )}
                        <div
                          className={`h-20 text-center flex items-center justify-center w-full text-[var(--successGreen)] rounded-br-lg font-family-medium ${
                            actionsDisabled ? "bg-[#f5f5f5] cursor-not-allowed opacity-50" : "bg-[#CCF7BF] cursor-pointer"
                          }`}
                          onClick={actionsDisabled ? undefined : () =>
                            approveHandler(
                              sendRowDataInHandler ? rowData : rowData?.parentId
                            )
                          }
                        >
                          Approve
                        </div>
                      </>
                    );
                  })()}
                </div>
              ) : null}
              </div> }
            </div>
          </>
        );
      })}
    </div>
  );
};

export default DetailsCard;
